import { Rule, FingerprintedTxn, StagedTxn } from '../money.model';

export function matchesRule(matchKey: string, rule: Rule): boolean {
  const key = (matchKey ?? '').toUpperCase();
  const pattern = (rule.pattern ?? '').toUpperCase();
  switch (rule.match) {
    case 'contains':   return key.includes(pattern);
    case 'startsWith': return key.startsWith(pattern);
    case 'exact':      return key === pattern;
    case 'regex':
      try { return new RegExp(rule.pattern, 'i').test(matchKey ?? ''); }
      catch { return false; }          // a broken rule must never break an import
    default:           return false;
  }
}

/**
 * Pure. Rules run in priority order, first match wins; ties break on id so the
 * result is deterministic.
 *
 * `duplicateFingerprints` is the set already stored in RTDB — passing it here
 * keeps the preview a single pass over the data.
 */
export function applyRules(
  txns: FingerprintedTxn[],
  rules: Rule[],
  duplicateFingerprints: Set<string> = new Set(),
): StagedTxn[] {
  const ordered = [...rules].sort(
    (a, b) => a.priority - b.priority || a.id.localeCompare(b.id));

  return txns.map(t => {
    const hit = ordered.find(r => matchesRule(t.matchKey, r));
    return {
      ...t,
      categoryId: hit?.categoryId ?? null,
      // Never clear a flag the adapter set (Apple Type=Payment).
      isTransfer: t.isTransfer || !!hit?.isTransfer,
      matchedRuleId: hit?.id ?? null,
      isDuplicate: duplicateFingerprints.has(t.fingerprint),
    };
  });
}

/** Suggests a rule pattern from a match key: the leading merchant words. */
export function derivePattern(matchKey: string): string {
  const words = (matchKey ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  return words.slice(0, 3).join(' ');
}
